import { gql } from '@apollo/client';

export const REFRESH_TOKEN_MARKET_DATA = gql`
  mutation RefreshTokenMarketData($tokenId: ID!) {
    refreshTokenMarketData(tokenId: $tokenId)
  }
`;

export const SET_CHART_SYMBOL = gql`
  mutation SetChartSymbol($tokenId: ID!, $chartSymbol: String) {
    setChartSymbol(tokenId: $tokenId, chartSymbol: $chartSymbol)
  }
`;

export const UPDATE_TOKEN = gql`
  mutation UpdateToken($id: ID!, $name: String, $ticker: String, $coingeckoId: String) {
    updateToken(id: $id, name: $name, ticker: $ticker, coingeckoId: $coingeckoId)
  }
`;

export const UPDATE_TOKEN_MARKETDATA = gql`
  mutation UpdateTokenMarketData($id: ID!) {
    updateTokenMarketData(id: $id)
  }
`; 